export class PrinterDeviceItem {
	pk: string; //PRINTER_DEVICE_:venueKey
	sk: string; //:PRINTER_KEY
	posId: number;
	name: string;
	controllingPosDeviceId: number;
	created: string;
	lastHeartbeat: string;
	lastPrintJobDateTime: string;
	lastPrintJobKey: string;
	adopted: boolean = false;

	controllingPosDeviceName: string;

	public constructor(init?: Partial<PrinterDeviceItem>) {
		Object.assign(this, init);
	}
}
